import getters from '@/store/lib/getters'

export default {
  ...getters
}
